import { render } from "./CompareModel.vue?vue&type=template&id=8053d956"
import script from "./CompareModel.vue?vue&type=script&lang=js"
export * from "./CompareModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__